import Button from '../Button';
import FlexContainer from '../FlexContainer';
import Modal from '../Modal';
import Txt from '../Txt';
import styles from './NoSubscriptionInfo.module.scss';

/**
 * NoSubscriptionInfo
 *
 * @return {JSX.Element}
 */
const NoSubscriptionInfo = ({ className, onClose, ...rest }) => {
  return (
    <Modal
      {...rest}
      onClose={onClose}
      title="No Active Subscription"
      showCloseButton
    >
      <FlexContainer className={styles.NoSubscriptionInfo} column gap>
        <Txt regular>
          We hope the free trial gave you an opportunity to see if Propa works
          for you and your business. To unlock full access to Propa's property
          management services, please purchase a subscription.
        </Txt>
        <Txt regular>
          If you wish to cancel your subscription you can do this in: Tools >
          Subscriptions > Manage my Subscription.
        </Txt>
        <Txt regular>
          Please note if you cancel, access to your properties in the Propa app
          will be limited after your last billing month has ended.
        </Txt>
        <Button success onClick={onClose}>
          Dismiss
        </Button>
      </FlexContainer>
    </Modal>
  );
};

NoSubscriptionInfo.displayName = 'NoSubscriptionInfo';

export default NoSubscriptionInfo;
